import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/services/storage.service';
import { NgxSpinnerService } from 'ngx-spinner'; 

@Component({
  selector: 'app-razor-pay',
  templateUrl: './razor-pay.component.html',
  styleUrls: ['./razor-pay.component.css'],
  standalone: false,
})
export class RazorPayComponent implements OnInit {
  @ViewChild('paymentScreen') paymentScreen: TemplateRef<any>;

  isSuccess: boolean | null = null;
  orderId: string = '';

  constructor(
    private activeRouter: ActivatedRoute,
    private paymentService: PaymentService,
    private modalService: NgbModal,
    private router: Router,
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.spinner.hide();

    this.activeRouter.queryParams.subscribe((params) => {
      const referenceId = params['razorpay_payment_link_reference_id'];
      this.orderId = referenceId ? referenceId.substring(3) : 'N/A';

      if (params['razorpay_payment_link_status'] === 'paid') {
        this.isSuccess = true;
        this.storageService.setOrderId(this.orderId); 
        this.storageService.setPaymentStatus('payment_successfull');
      } else {
        this.isSuccess = false;
        this.storageService.setPaymentStatus('payment_failed');
      }

      const paymentUpdate = {
        status: params['razorpay_payment_link_status'] || 'failed',
        timestamp: new Date().getTime(),
      };
      localStorage.setItem('doqfy_payment_update', JSON.stringify(paymentUpdate));

      // if (params['razorpay_payment_id']) {
      //   this.showPaymentDetails(params);
      // }
    });
  }

  // showPaymentDetails(params: any) {
  //   let payload = {
  //     razorpay_payment_id: params['razorpay_payment_id'] || '',
  //     razorpay_payment_link_id: params['razorpay_payment_link_id'] || '',
  //     razorpay_payment_link_status: params['razorpay_payment_link_status'] || '',
  //     razorpay_signature: params['razorpay_signature'] || '',
  //     razorpay_payment_link_reference_id: params['razorpay_payment_link_reference_id'] || '',
  //   };
    

  //   this.paymentService.getPaymentStatus(payload).subscribe({
  //       next: (res) => {
  //           console.log("Backend successfully processed Razorpay callback", res);
  //       },
  //       error: (err) => {
  //           console.error("Failed to update backend with Razorpay status", err);
  //       }
  //   });
  // }

  closeModel() {
    this.modalService.dismissAll();
  }

  goToOrderList() {
    this.router.navigate(['doqfy/orders/orders-list'], {
      queryParams: { openOrderId: this.orderId },
    });
  }
}